import { render, staticRenderFns } from "./get-customer-by-code.vue?vue&type=template&id=c72bbd3e"
import script from "./get-customer-by-code.vue?vue&type=script&lang=js"
export * from "./get-customer-by-code.vue?vue&type=script&lang=js"
import style0 from "./get-customer-by-code.vue?vue&type=style&index=0&id=c72bbd3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports